import { API } from '../../utils';
import { IParams } from '../types';
import { GW_SERVICES_PREFIXES } from '../../constants';

const { C300 } = GW_SERVICES_PREFIXES;

export const GetHouseById = (id: string) =>
  API.get(`/${C300}/models/houses/`, id);

/* Получить дома организации */
export const GetProviderHouses = (params: IParams) =>
  API.get(`/${C300}/forms/provider/houses/`, undefined, params);
